export default __webpack_public_path__ + "static/media/three-dots.01f0d9f3.svg";